import { ArticlesList } from '../../components';
import { withLayout } from '../../Layout/Layout';
import Head from 'next/head';
import React from 'react';

function TopLists() {
  return (
    <>
      <Head>
        <meta
          name="description"
          content={
            'Access curated top lists of travel guides and resources on First-Class.com. Discover expert-recommended destinations and experiences'
          }
        />
        <title>Guide Toplists: Ranking the Best Travel Guides</title>
      </Head>
      <ArticlesList
        subtype="Toplists"
        type="Guides"
        heading="Finest Selection"
      />
    </>
  );
}

export default withLayout(TopLists, true);
